import type { ReactNode } from 'react';

// Reusable semantic badge per the design spec. Four variants only —
// neutral / accent / positive / alert. Renders as a tight uppercase
// 9px pill with hairline borders and tabular nums. If you find
// yourself wanting a 5th variant, you've drifted from semantic to
// decorative.

export type BadgeVariant = 'neutral' | 'accent' | 'positive' | 'alert';

export function Badge({
  variant = 'neutral',
  children,
}: {
  variant?: BadgeVariant;
  children: ReactNode;
}) {
  return <span className={`badge badge-${variant}`}>{children}</span>;
}
